export { AboutCardSecondary } from './AboutCardSecondary';
